import { useState, useEffect, useContext } from "react";
import styled, { keyframes } from "styled-components";
import { BsFillPencilFill } from "react-icons/bs";
import { IoRestaurantOutline } from "react-icons/io5";
import { LuChefHat } from "react-icons/lu";
import { BsCalendar2Event } from "react-icons/bs";
import API from "../../API";
import AuthContext from "../../context/AuthContext";
import ModalHeaderServices from "./Modal";

const ICONS = [
  <IoRestaurantOutline key="restaurant" />,
  <LuChefHat          key="chef" />,
  <BsCalendar2Event   key="calendar" />,
];

export default function Service() {
  const [modalShow, setModalShow] = useState(false);
  const [services,  setServices]  = useState([]);
  const { user }                  = useContext(AuthContext);

  useEffect(() => { refreshService(); }, []);

  const refreshService = () => {
    API.get("/api/Service/")
      .then((res) => setServices(res.data))
      .catch(console.error);
  };

  const handleMessageChange = (event) => {
    if (!services[0]) return;
    if (event.target.id === "content1") services[0].content1 = event.target.value;
    if (event.target.id === "content2") services[0].content2 = event.target.value;
    if (event.target.id === "content3") services[0].content3 = event.target.value;
  };

  const handleSubmit = () => {
    if (!services[0]) return;
    if (services[0].id) {
      API.put(`api/Service/${services[0].id}/`, services[0]).then(() => refreshService());
    } else {
      API.post("api/Service/", services).then(() => refreshService());
    }
    setModalShow(false);
  };

  if (!services.length) return null;

  const svc   = services[0];
  const cards = [svc.content1, svc.content2, svc.content3].filter(Boolean);

  return (
    <Section>
      <Grid>
        {cards.map((content, i) => (
          <FeatureCard key={i}>
            <IconCircle>{ICONS[i]}</IconCircle>
            <CardText>{content}</CardText>
            {user && i === cards.length - 1 && (
              <EditBtn onClick={() => setModalShow(true)} title="Modifier">
                <BsFillPencilFill />
              </EditBtn>
            )}
          </FeatureCard>
        ))}
      </Grid>

      <ModalHeaderServices
        show={modalShow}
        onHide={() => setModalShow(false)}
        handleSubmit={handleSubmit}
        activeItem={svc}
        onChange={handleMessageChange}
      />
    </Section>
  );
}

/* ─── Keyframes ─── */
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/* ─── Styled Components ─── */

const Section = styled.section`
  padding: 4rem 5vw 5rem;
  background: var(--bg-base);
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 900px)  { grid-template-columns: 1fr; max-width: 520px; }
  @media (max-width: 600px)  { gap: 1rem; }
`;

const FeatureCard = styled.div`
  position: relative;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 2.25rem 1.75rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.1rem;
  text-align: center;
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  animation: ${fadeUp} 0.6s ease both;

  &:nth-child(1) { animation-delay: 0.05s; }
  &:nth-child(2) { animation-delay: 0.15s; }
  &:nth-child(3) { animation-delay: 0.25s; }

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(200, 151, 62, 0.35);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
  }

  /* top accent bar */
  &::before {
    content: "";
    position: absolute;
    top: 0; left: 20%; right: 20%;
    height: 2px;
    background: linear-gradient(to right, transparent, var(--primary), transparent);
    border-radius: 0 0 4px 4px;
  }
`;

const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: var(--primary-glow);
  border: 1px solid var(--border);
  border-radius: 50%;
  color: var(--primary);
  font-size: 1.5rem;
  flex-shrink: 0;
`;

const CardText = styled.p`
  font-size: 0.92rem;
  color: var(--cream-dim);
  line-height: 1.8;
  letter-spacing: 0.03em;
`;

const EditBtn = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: none;
  border: 1px solid var(--border);
  color: var(--primary);
  font-size: 0.75rem;
  width: 26px;
  height: 26px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);

  &:hover { background: var(--primary-glow); }
`;
